import { css } from '@emotion/core'
import { palette } from '~/utils/colors'

export const link_text = css`
	text-decoration: underline;
	
	:hover {
		color: ${palette.primary.light};
	}
`